<template>
  <div class="login">
    <v-card>
      <v-card-text>
        <v-form ref="login_form" :v-model="valid" lazy-validation method="get">
          <v-text-field
            prepend-icon="mdi-account"
            v-model="userName"
            :rules="[
                            rules.required_user_name,
                        ]"
            name="username"
            label="ユーザ名を入力する"
            type="text"
            id="id_username"
          ></v-text-field>
          <v-text-field
            id="id_password"
            v-model="password"
            prepend-icon="mdi-key"
            :rules="[
                            rules.required_password,
                            rules.format_password,
                            rules.min_length_password,
                            rules.max_length_password
                        ]"
            type="password"
            name="password"
            label="パスワードを入力する"
            counter
          ></v-text-field>
          <v-alert
            class="login__alert"
            :value="validError"
            type="error"
            transition="scale-transition"
          >ログイン情報に誤りがあります。</v-alert>
          <v-checkbox class="login__checkbox" v-model="mail_memory" label="ユーザ名を記録" color="primary"></v-checkbox>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="login()">ログイン</v-btn>
            <input type="hidden" name="csrfmiddlewaretoken" id="csrfid" v-bind:value="csrftoken" />
            <input type="hidden" name="validVal" id="validid" />
          </v-card-actions>
          <div>ROUNDNAVI-WEB管理画面のご利用にはGoogle Chromeをご使用ください。</div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { GET_ADMINLOGIN } from '../constants/login';
import validater from '../lib/validater';

export default {
    data () {
        return {
            // 入力フォームのバリデーションチェック
            valid: false,
            // パスワード項目の可視化：デフォルトは非表示
            show1: false,
            // バリデーションチェック項目の表示制御
            validError: false,
            mail_memory: false,
            // ユーザ名
            userName: '',
            name: '',
            // パスワード
            password: '',
            allPayrolls: [],
            csrftoken: '',
            // バリデーションチェック
            rules: {
                required_user_name: v =>
                    !!v || this.$t('error.validation.required.userName'),
                required_password: v =>
                    !!v || this.$t('error.validation.required.password'),
                format_password: v =>
                    validater.checkStringType(v) ||
          this.$t('error.validation.stringtype'),
                min_length_password: v =>
                    v.length >= 10 || this.$t('error.validation.length.adminPasswordMin'),
                max_length_password: v =>
                    v.length <= 128 || this.$t('error.validation.length.passwordMax')
            },
            loginCount: [{ count: 0 }]
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        initialize: function () {
            // メールアドレスの記憶状態チェック
            // 記憶時はアドレスならびに記憶チェック値をセット
            if (localStorage.getItem('ad-mail-memory')) {
                this.userName = localStorage.getItem('ad-login-mail');
                this.mail_memory = localStorage.getItem('ad-mail-memory');
            }
        },
        /** ------------------------------
     * ログイン処理
     * ------------------------------ */
        login: async function () {
            localStorage.removeItem('apollo-token');
            // 必須項目の入力チェック
            if (this.$refs.login_form.validate()) {
                // loading画面を表示させる
                this.$store.commit('loading/setIsLoading', true);
                try {
                    let res = await this.$apollo.query({
                        query: GET_ADMINLOGIN,
                        fetchPolicy: 'no-cache',
                        variables: { user_name: this.userName, password: this.password }
                    });
                    localStorage.setItem('apollo-token', res.data.adminLogin.accessToken);
                    this.validError = false;

                    // メールアドレスの記憶状態セット処理
                    if (this.mail_memory) {
                        localStorage.setItem('ad-login-mail', this.userName);
                        localStorage.setItem('ad-mail-memory', this.mail_memory);
                    } else {
                        localStorage.removeItem('ad-login-mail');
                        localStorage.removeItem('ad-mail-memory');
                    }
                    // 成功時はroute.pushしているので、
                    // ルーティング先でloadingがfalseになる(route/index.js参照)
                    this.$router.push('/');
                } catch (error) {
                    this.validError = true;
                    // 処理失敗時はloadingを戻す
                    this.$store.commit('loading/setIsLoading', false);
                }
            }
        }
    }
};
</script>
